import * as React from "react";
import { Switch } from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider"; 
import TooltipWatcherWidget from "../TooltipWatcherWidget";

export default function DateFormatToggle()  {
  // Pulling the current value and the setter from your global state
  const { dateToggle, setDateToggle } = useGlobalStatus();
  const onToggleChange = (ev, data) => {
    // data.checked returns true/false
    setDateToggle(data.checked);
  };
  
  return (
    <TooltipWatcherWidget text="Click to show the times with Hours and Minutes rather than an Hour with a decimal" direction="below-end">
      <Switch
        label={<span style={{ color: 'black' }}>Time Format</span>}
        checked={dateToggle === true}
        onChange={onToggleChange}
        onText="Detailed"
        offText="Standard"
        styles={{ label: { color: 'black' } }}/>
    </TooltipWatcherWidget>
  );
};